var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.058,
    height: 42.164,
    viewBox: "0 0 52.058 42.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-329.684 -496.751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.333,44.779,34.719,34.741a.881.881,0,0,0,0-1.526L17.333,23.174a.881.881,0,0,0-1.322.763v4.674H1a.882.882,0,0,0-.881.881V38.46A.882.882,0,0,0,1,39.341H16.011v4.674a.883.883,0,0,0,1.322.765Z",
    transform: "translate(364.843 551.809) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.867,0H38.907a.882.882,0,0,0-.881.881V3.526a.882.882,0,0,0,.881.881h17.96a2.105,2.105,0,0,1,2.1,2.1V35.654a2.105,2.105,0,0,1-2.1,2.1H38.907a.882.882,0,0,0-.881.881v2.644a.882.882,0,0,0,.881.881h17.96a6.517,6.517,0,0,0,6.51-6.51V6.511A6.518,6.518,0,0,0,56.867,0Z",
    transform: "translate(318.364 496.751)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1d47a11453e112c60c46d21cf19d56ca.svg";
export { ForwardRef as ReactComponent };